<template>
    <div class="articles_block">
        <h4>Recent Post</h4>
        <div class="articles_flex font-active">
            <div class="articles_box" v-for="item in data" :key="item.id">
                <router-link :to="localePath('/blog/'+item.slug)">
                    <img class="radious_eight" width="277" height="403" :alt="item.title" :src="item.image">
                    <!-- <span class="art_name">SEBASTIAN x TAKAGAWA</span> -->
                    <span class="art_title">{{ item.title }}</span>
                </router-link>
            </div>
            
        </div>
    </div>
</template>

<script setup>
    const localePath = useLocalePath()
    const {data} = defineProps(['data'])
</script>

<style scoped>
.articles_block {
    width: 280px;
}

.art_container {
    display: flex;
    justify-content: flex-end;
}

h4 {
    font-size: 16px;
    text-transform: uppercase;
    font-weight: 600;
    margin-bottom: 32px;
}

.articles_box span.art_name {
    display: block;
    font-size: 14px;
    padding: 19px 0 8px;
}

.articles_box span.art_title {
    display: block;
    font-size: 20px;
    line-height: 1.3;
    padding: 19px 0 8px;
}

.articles_box a {
    color: #000;
}

.articles_box {margin-bottom: 32px;}
</style>
